import { useNavigate } from "react-router-dom";
import { User, LogOut, FileSpreadsheet, BarChart2, Scale, Building2, Leaf, TrendingUp, ClipboardList, LineChart, CalendarDays, BarChart, Wallet, BookLock } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export default function HaciendaPresupuesto() {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const displayName =
    user?.email ||
    user?.correo ||
    user?.username ||
    "hpresupuesto@desarrollando.com";

  const roleId =
    user?.role_id ??
    user?.rolId ??
    user?.roleId ??
    user?.rol_id ??
    13;

  const handleLogout = () => {
    if (typeof logout === "function") {
      logout();
    }
    localStorage.removeItem("auth_user");
    localStorage.removeItem("auth_token");
    sessionStorage.removeItem("auth_user");
    sessionStorage.removeItem("auth_token");
    window.location.replace("/login");
  };

  const cards = [
    {
      icon: <FileSpreadsheet size={28} />,
      title: "Transformador presupuestal",
      description:
        "Carga archivos de ingresos, egresos o resumen unificado y genera automáticamente el archivo transformado en Excel.",
      onClick: () => navigate("/hacienda-presupuesto/transformador"),
    },
    {
      icon: <BarChart2 size={28} />,
      title: "Indicador de ley 617 Administración Central",
      description:
        "Consulta y analiza los indicadores presupuestales establecidos por ley a partir de los datos consolidados.",
      onClick: () => navigate("/hacienda-presupuesto/indicadores-ley"),
    },
    {
      icon: <Scale size={28} />,
      title: "Concejo Municipal",
      description:
        "Cálculo de honorarios de concejales según Art. 10 Ley 617/2000. Gestiona vigencias, IPC y genera el histórico de cálculos.",
      onClick: () => navigate("/hacienda-presupuesto/concejo-honorarios"),
    },
    {
      icon: <Building2 size={28} />,
      title: "Personería Municipal",
      description:
        "Límite al gasto de la personería según Ley 2422/2024. Calcula el tope por categoría usando SMMLV o % ICLD.",
      onClick: () => navigate("/hacienda-presupuesto/personeria"),
    },
    {
      icon: <Leaf size={28} />,
      title: "Indicador Ley 99/93",
      description:
        "Calcula el 1% de los ingresos corrientes de libre destinación para la tasa ambiental.",
      onClick: () => navigate("/hacienda-presupuesto/ley-99-93"),
    },
    {
      icon: <TrendingUp size={28} />,
      title: "Seguimiento Presupuestal",
      description:
        "Consolidado de ingresos y egresos con filtro por fuente de financiación y totales por sección.",
      onClick: () => navigate("/hacienda-presupuesto/seguimiento"),
    },
    {
      icon: <ClipboardList size={28} />,
      title: "Rendición PIIP",
      description:
        "Plan Indicativo de Inversión Pública.",
      onClick: () => navigate("/hacienda-presupuesto/piip"),
    },
    {
      icon: <LineChart size={28} />,
      title: "Proyección de Ingresos",
      description:
        "Carga ejecuciones históricas por vigencia y proyecta los ingresos de la siguiente vigencia usando los 5 métodos del Ministerio de Hacienda.",
      onClick: () => navigate("/hacienda-presupuesto/proyeccion-ingresos"),
    },
    {
      icon: <CalendarDays size={28} />,
      title: "Proyección de Ingresos Vigencia Actual",
      description:
        "Carga ejecuciones mensuales de la vigencia en curso (mínimo 3, máximo 11 meses) y proyecta el comportamiento de los ingresos del año.",
      onClick: () => navigate("/hacienda-presupuesto/proyeccion-vigencia-actual"),
    },
    {
      icon: <BarChart size={28} />,
      title: "PAC Ingresos",
      description:
        "Plan Anual de Caja de ingresos. Visualiza la distribución mensual de cada cuenta con histórico y porcentaje de participación.",
      onClick: () => navigate("/hacienda-presupuesto/pac-ingresos"),
    },
    {
      icon: <Wallet size={28} />,
      title: "Proyección Ingresos Recursos del Balance",
      description:
        "Carga el Excel de adición presupuestal y visualiza la estructura de ingresos del balance con títulos y detalles según el Anexo 1A.",
      onClick: () => navigate("/hacienda-presupuesto/recursos-balance"),
    },
    {
      icon: <BookLock size={28} />,
      title: "Cierre Fiscal",
      description:
        "Gestión del cierre de la vigencia presupuestal.",
      onClick: () => navigate("/hacienda-presupuesto/cierre-fiscal"),
    },
  ];

  return (
    <div style={{ minHeight: "100vh", background: "#f3f4f6", padding: "3rem 1.5rem" }}>
      <div style={{ maxWidth: "1100px", margin: "0 auto", textAlign: "center" }}>

        <div style={{ marginBottom: "2rem" }}>
          <h1 style={{ fontSize: "2.6rem", fontWeight: "800", color: "#163b8c", margin: 0 }}>
            Hacienda
          </h1>
          <p style={{ marginTop: "0.9rem", color: "#6b7280", fontSize: "1.05rem" }}>
            Herramientas para transformación y consolidación de archivos presupuestales
          </p>
        </div>

        <div style={{ display: "flex", justifyContent: "center", alignItems: "center",
          gap: "1rem", flexWrap: "wrap", marginBottom: "2.5rem" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "0.65rem",
            background: "#eef2ff", color: "#1e3a8a", padding: "0.85rem 1.15rem",
            borderRadius: "999px", boxShadow: "0 2px 8px rgba(0,0,0,0.05)", fontSize: "0.95rem" }}>
            <User size={18} />
            <span>{displayName} (Rol {roleId})</span>
          </div>

          <button type="button" onClick={handleLogout}
            style={{ display: "flex", alignItems: "center", gap: "0.5rem",
              background: "#ef4444", color: "#fff", border: "none",
              padding: "0.9rem 1.3rem", borderRadius: "999px", cursor: "pointer",
              fontWeight: "600", boxShadow: "0 4px 12px rgba(239,68,68,0.25)" }}>
            <LogOut size={18} />
            Cerrar sesión
          </button>
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
          gap: "1.5rem", textAlign: "left" }}>
          {cards.map((card) => (
            <div key={card.title} onClick={card.onClick} role="button" tabIndex={0}
              onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") card.onClick(); }}
              style={{ background: "#ffffff", border: "1px solid #e5e7eb",
                borderRadius: "20px", padding: "1.8rem",
                boxShadow: "0 8px 24px rgba(0,0,0,0.06)", cursor: "pointer",
                transition: "transform 0.2s ease, box-shadow 0.2s ease" }}>
              <div style={{ width: "58px", height: "58px", borderRadius: "16px",
                background: "#eef2f7", display: "flex", alignItems: "center",
                justifyContent: "center", marginBottom: "1rem", color: "#374151" }}>
                {card.icon}
              </div>
              <h2 style={{ margin: 0, marginBottom: "0.75rem", fontSize: "1.8rem",
                color: "#163b8c", fontWeight: "800" }}>
                {card.title}
              </h2>
              <p style={{ margin: 0, color: "#5b6472", fontSize: "1rem", lineHeight: 1.7 }}>
                {card.description}
              </p>
            </div>
          ))}
        </div>

      </div>
    </div>
  );
}